import axios from '../../plugins/axios.locality';

export default {
  getAllCountries() {
    return axios.default().get('/countries');
  },
  getStatesByCountry(countryCode, params) {
    return axios.default().get(`countries/${countryCode}/states`, { params });
  },
  getCityByCountryAndByState(countryCode, stateCode, params) {
    return axios.default().get(`countries/${countryCode}/states/${stateCode}/cities`, { params });
  },
  getLocalities(params) {
    return axios.default().get('/localities', { params });
  }
};
